/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Aneinverstaendniserklaerungen2Inputs */



/**

* @param {_Field_Aneinverstaendniserklaerungen2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_aneinverstaendniserklaerungen2 = /** @type {((inputs?: _Field_Aneinverstaendniserklaerungen2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Aneinverstaendniserklaerungen2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Einverstanden mit Erklärungen")
});
export { _field_aneinverstaendniserklaerungen2 as "_field_anEinverstaendnisErklaerungen" }